const momenttimethai = (data) => {
  var moment = require('moment')
  return (moment(data).tz('Asia/Bangkok').lang('th').format('LT'))
}
const momentdatethai = (data) => {
  var moment = require('moment')
  return moment(data).tz('Asia/Bangkok').lang('th').format('ll')
}

const momenttimethaiformnow = (data) => {
  var moment = require('moment')
  return moment(moment(data).tz('Asia/Bangkok').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').lang('th').fromNow()
}

const momenttimestamp = () => {
  var moment = require('moment')
  return ((moment().tz('Asia/Bangkok').format()).replace(/T/g, ' ')).replace('Z', '')
}

const momentdatetimethai = (data) => {
  var moment = require('moment')
  return moment(data).tz('Asia/Bangkok').lang('th').format('llll').split('เวลา')[0]
}


export default {
  momenttimethai,
  momentdatethai,
  momenttimethaiformnow,
  momenttimestamp,
  momentdatetimethai
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js